<template>
    <div class="container pb-2 slider-fotos" :style="`min-height: 380px;`">
        <div class="text-center font-glacial-regular font-70 mb-4" v-html="tituloComputed">
            
        </div>
        <!-- <div class="d-flex justify-content-center">
            <div class="col-xl-10 text-gray-light text-center font-regular font-18 mb-4 pb-3">
                <span :style="`line-height: 1.9;`">{{data.descricao}}</span>
            </div>
        </div> -->

        <div ref="observerFotos"></div>
        <transition enter-active-class="animated fadeInUp">
            <slick class="mb-xl-5 mb-0 pb-4" :options="slickOptions" v-if="showObserver">
                <div class="d-flex mb-2 justify-content-center align-items-center" v-for="(d, index) in data.fotos" :key="index">
                    <div class=" col-xl-10 height-589 height-mobile"
                    :style="`background-position: center; 
                        background-size: cover; 
                        border-radius: 10px; 
                        background-image: url(${d.foto.url})`">
                    </div>
                </div>
            </slick>
        </transition>
        
    </div>
</template>
<script>
    import observer from 'intersection-observer';

    export default {
        props:{
            data : null
        },

        data(){
            return {
                showObserver: false,

                slickOptions:{
                    arrows: true,
                    infinite: true,
                    responsive: [
                    {
                        breakpoint: 1025,
                        settings:{
                            arrows: false
                        }
                    }
                ]
                }
            }
        },

        mounted(){
            var observer = new IntersectionObserver((entries) => {
                // If intersectionRatio is 0, the target is out of view
                // and we do not need to do anything.
                if (entries[0].intersectionRatio <= 0) {
                    return;
                }
                this.showObserver = true
                observer.unobserve(this.$refs.observerFotos)

            });

            observer.POLL_INTERVAL = 100;
            observer.observe(this.$refs.observerFotos)
        },

        computed:{
            tituloComputed(){
                var result = this.data.titulo
                var firstWord = result.substr(0, result.indexOf(" "));
                result = result.replace(firstWord, "");

                firstWord = `<strong>${firstWord}</strong>`

                result = firstWord + result

                return result
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/widgets/slider_fotos.vue